import React, { useState } from "react";
import ReactPaginate from "react-paginate";
import Product from "../../home/Products/Product";

function Items({ currentItems, orderType }) {
  return (
    <>
      {currentItems &&
        currentItems.map((item) => {
          const priceToShow = item[orderType]; 
          // Example: item["general_price"] OR item["wholesale_price"]

          return (
            <div key={item.id} className="w-full">
              <Product
                _id={item.id}
                img={`${process.env.REACT_APP_API_URL}/public/${item.image}`}
                productName={item.name}
                price={item.wholesale_price}       // 👈 send correct price
                color=""
                badge=""
                des={item.description}
              />
            </div>
          );
        })}
    </>
  );
}

const Pagination = ({ items, itemsPerPage, orderType}) => {
  const [itemOffset, setItemOffset] = useState(0);
  const [itemStart, setItemStart] = useState(1);

  const endOffset = itemOffset + itemsPerPage;

  const currentItems = items.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(items.length / itemsPerPage);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % items.length;
    setItemOffset(newOffset);
    setItemStart(newOffset + 1);
  };

  return (
    <div>
      {/* PRODUCT GRID - SAME DESIGN */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-10 mdl:gap-4 lg:gap-10">
        <Items currentItems={currentItems} orderType={orderType}/>
      </div>

      {/* PAGINATION SECTION - SAME DESIGN */}
      <div className="flex flex-col mdl:flex-row justify-center mdl:justify-between items-center">
        <ReactPaginate
          nextLabel=""
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          marginPagesDisplayed={2}
          pageCount={pageCount}
          previousLabel=""
          pageLinkClassName="w-9 h-9 border-[1px] border-lightColor hover:border-gray-500 duration-300 flex justify-center items-center"
          pageClassName="mr-6"
          containerClassName="flex text-base font-semibold font-titleFont py-10"
          activeClassName="bg-black text-white"
        />

        <p className="text-base font-normal text-lightText">
          Products from {itemStart} to {endOffset > items.length ? items.length : endOffset} of{" "}
          {items.length}
        </p>
      </div>
    </div>
  );
};

export default Pagination;
